import { AreaType, RuleAction, UserType, VideoType } from "../../enum";
import { TagFilter } from "../../models/TagFilter";

export interface Appointment {
  contractId: number;
  stage: number;
  clientEmail: string;
  coClientEmail: string;
  clientName: string;
  coClientName: string;
  showroomConsultant: string;
  showroomConsultantEmail: string;
  title: string;
  communityId: number;
  lotId: string;
  communityCode: string;
  options: Option[];
  pricing: Pricing;
  profileImage: string;
  floorPlanWidth: string;
  floorPlanDepth: string;
  maxPadDepth: string;
  maxPadWidth: string;
  upgradedFoundation: string;
  maxPrequalAmount: string;
  standardFoundation: string;
  floorPlanNumber: string;
  floorPlans: string;
  builder: string;
  trueAdvisorName: string;
  collection: string;
  community_Lots: string;
  lotAddress: string;
  elevation: string;
  showRoomBudget: string;
  handling: string;
  structuralOptionsSR: string;
  totalPriceBeforeSelection: string;
  collectionId: number;
  floorplanId: number;
  variantId: number;
  appointmentDate: Date;
  lastUpdatedDate: Date;
  loginBy: UserType;
  tutorialVideos: TutorialVideo[];
  isClientLoginBlocked: boolean;
}
export interface TutorialVideo {
  id: number;
  url: string;
  isWatched: boolean;
  thumbnail: string;
  title: string;
  description: string;
  sortOrder: string;
  videoType: VideoType;
  disableClose: boolean;
  showNotifictaion: boolean;
}

export interface CFAOptions {
  parentDisplayOrder: number;
  displayOrder: number;
  areaName: string;
  areaId: number;
  options: Option[];
}

export interface Option {
  isPinnable: boolean;
  allStylesSelected: boolean;
  isUsingStylePlaceholder: boolean;
  isPackage: boolean;
  isExcluded: boolean;
  prepared: boolean;
  isDefault: boolean;
  isRequired: boolean;
  isHiddenByDefault: boolean;
  isHiddenByRule: boolean;
  isIncluded: boolean;
  areaId: number;
  id: number;
  optionId: number;
  description: string;
  isIncludedFeature: boolean;
  childOptions?: (Option)[] | null;
  model?: string | null;
  code?: string | null;
  rules?: (Rule | null)[] | null;
  price?: number | null;
  isQuantifiable?: boolean | null;
  hasIncludedFeature?: boolean | null;
  includedFeatureOptionId?: number | null;
  styleSelections?: (StyleSelection)[] | null;
  pictureUrl?: string | null;
  displayName?: string | null;
  cardDisplayName?: string | null;
  triggersRules: boolean;
  thumbnailUrl?: string | null;
  quantity: number;
  isClientSelected: boolean | null;
  exclusiveRules: string | null;
  subDescription: string;
  collectionId: number;
  baseCollection: string;
  // Virtual Design Studio Properties
  parentOptionId?: number;
  isSelected: boolean;
  isVisible: boolean;
  isLiked: boolean;
  customBannerIncludedImage?: string | null;
  customBannerOptionalImage?: string | null;
  isFeatureGroup?: boolean | null;

  // These property is populated by the application, not the service.  It's NOT mapped
  selectedOption: Option;
  selectionRequired: boolean;
  isPanelOpen: boolean;
  selectedPictureGallery: string[];
  parentAreaId: number;
  oldQuantity: number;
  isExpand: boolean;
  isCompareChecked: boolean;

  defaultGalleryPicture: string;
  defaultGalleryPictureMissing: boolean;
  areaName: string;
  area: SubArea;
  isAdded: boolean;
  isRFP: boolean;
  isStyleSelected: boolean;
  tags: string[];
  tag: string;
  filter: TagFilter;
  appliedFilter: string;
  needDiscussion: boolean;
  discussionNotes: string;
  details: string;
  // For sorting relevance
  matchCount: number;
  isHidden: boolean;
  ruleSourceOptionId: number;
}

export interface Rule {
  description: string;
  optionId: number;
  action: RuleAction;
  ruleSourceOptionId: number;
}

export interface StyleSelection {
  isExcluded: boolean;
  optionId: number;
  description: string;
  displayName: string;
  name: string;
  styleChoices?: (StyleChoice)[] | null;
  displayOrderId: number;

  // Non-service properties
  selectedStyle: StyleChoice;
  isExpand: boolean;
}

export interface StyleChoice {
  mediumThumbnailUrl: string;
  optionId: number;
  description: string;
  pictureUrl: string;
  isDefault?: boolean;
  thumbnailUrl?: string | null;
  displayName?: string | null;
  // Virtual Design Studio Properties
  parentOptionId?: number;
  isSelected: boolean;
  isVisible: boolean;
  isLiked: boolean;

  // Options marked as removed should never show up.
  isRemoved: boolean;
}
export interface Tag {
  name: string;
  isVisited: boolean;
  status: string;
}

export interface Area {
  id: number;
  name: string;
  areaHelpText: string;
  imageUrl: string;
  opacity: number;
  optionTotal: string;
  displayOrder: number;
  isSelected: boolean;
  areaIcon: string;
  subAreas: SubArea[];
  isVisited: boolean;
  status: string;
  areaType: AreaType
  helpTextHidden: boolean;
}

export interface SubArea {
  id: number;
  name: string;
  displayOrder: number;
  parentDisplayOrder: number;
  parentName: string;
}

export class AuthPayload {
  contractId: number;
  email: string;
  password: string;
  isSuccessful: boolean;
  message: string;
  stage: number;
  appointment: Appointment;
  includeOptions: boolean;
  forceOptionRefresh: boolean;
  isLoggedIn: boolean;
  isImpersonating: boolean;
  isReadOnly: boolean;
  showPopup: boolean;
  id: string;
  role: string;
  token: string;
}

// GBJ: This is the pricing from the Design Studio.
// It's source of record is the design studio and these
// numbers should not change.  Calculations should be
// handled seperately from these numbers.

export interface Pricing {
  additionalFinanceCosts: number;
  changeOrders: number;
  elevationPrice: number;
  floorplanBasePrice: number;
  homesitePremium: number;
  maxApprovedPrice: number;
  oylSiteBudget: number;
  revisedPurchasePrice: number;
  optionsTotal: number;
  structuralOptionsAtDesignStudio: number;
  totalShowroomOptions: number;
  totalBeforeSelections: number;
  structuralOptionsAtContract: number;
  showRoomBudget: number;
  showRoomBudgetVds: number;
  revisedPurchasePriceVds: number;
}
export interface DialogData {
  displayName: string;
  selectedOption: number;
}

export interface Status {
  id: number;
  status: string;
}
export interface AreasTags {
  areaId: number;
  tag?: (Tag)[] | null;
}
